import React from 'react';
import { FiMessageCircle, FiExternalLink } from 'react-icons/fi';

import { Text, textVariantsEnum, fontWeightEnum } from '@components/Text';
import { Button, buttonVariants } from '@components/Button';
import { SUPPORT_PORTAL_URL } from '@/constants/support';

import styles from './HelpCard.module.scss';

const openSupportPortal = () =>
  window.open(SUPPORT_PORTAL_URL, '_blank', 'noopener,noreferrer');

export const HelpCard = () => (
  <div className={styles.helpCard}>
    <Text
      variant={textVariantsEnum.Text_md}
      fontWeight={fontWeightEnum.Semibold}
      color="gray-900"
    >
      Need help?
    </Text>
    <Text
      variant={textVariantsEnum.Text_sm}
      fontWeight={fontWeightEnum.Normal}
      color="gray-600"
      className={styles.description}
    >
      Learn more about settings and how they work.
    </Text>
    <FiMessageCircle size={22} className={styles.bubbleIcon} />
    <Button
      text="Visit Help Center"
      variant={buttonVariants.primary_outline}
      width="full"
      icon={<FiExternalLink size={14} />}
      iconPosition="right"
      onClick={openSupportPortal}
    />
  </div>
);

HelpCard.displayName = 'HelpCard';
